function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.25 6.25H20V0H5v6.25H3.75A3.755 3.755 0 000 10v8.75c0 1.379 1.121 2.5 2.5 2.5H5V25h15v-3.75h2.5c1.379 0 2.5-1.121 2.5-2.5V10a3.755 3.755 0 00-3.75-3.75zM7.5 2.5h10v3.75h-10V2.5zm10 20h-10v-5h10v5zm5-3.75H20V15H5v3.75H2.5V10c0-.689.561-1.25 1.25-1.25h17.5c.69 0 1.25.561 1.25 1.25v8.75z",
  fill: "#B4C0CF"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 10h5v2.5h-5V10z",
  fill: "#B4C0CF"
});

var SvgBespokenPrinter = function SvgBespokenPrinter(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgBespokenPrinter;